export default function ({
  locale = "en-US",
  style = "decimal",
  value,
  options = {},
}: {
  locale?: string;
  style: "decimal" | "currency" | "percent" | "unit";
  value: number;
  options?: Record<string, string | number>;
}) {
  return new Intl.NumberFormat(locale, {
    style,
    ...options,
  }).format(value);
}
